import { render, staticRenderFns } from "./CampaignLead.vue?vue&type=template&id=90f3eb4e&scoped=true"
import script from "./CampaignLead.vue?vue&type=script&lang=js"
export * from "./CampaignLead.vue?vue&type=script&lang=js"
import style0 from "./CampaignLead.vue?vue&type=style&index=0&id=90f3eb4e&prod&lang=scss&scoped=true"
import style1 from "./CampaignLead.vue?vue&type=style&index=1&id=90f3eb4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f3eb4e",
  null
  
)

export default component.exports